import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Button, Drawer, Heading } from "@foris/avocado-suite";
import { useLayoutStore } from "@context/useLayoutStore";
import styles from "./assignmentEditorDrawer.module.scss";

interface AssignmentEditorDrawerProps {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  disabled: boolean;
  onApply: () => void;
  onRequestClose: () => void;
  onClose: () => void;
}

const AssignmentEditorDrawer = ({
  isOpen,
  title,
  children,
  disabled,
  onApply,
  onRequestClose,
  onClose,
}: AssignmentEditorDrawerProps) => {
  const { t } = useTranslation();
  const heightGap = useLayoutStore(state => state.visibleHeaderPixels);
  return (
    <Drawer
      isOpen={isOpen}
      heightGap={heightGap}
      contentClassName={styles.panel}
      bodyPadding={false}
      title={<Heading type="h3">{title}</Heading>}
      onClose={onClose}
      closeOnOverlayClick
      footer={
        <div className={styles.actions}>
          <Button variant="ghost" onClick={onRequestClose}>
            {t("generals.cancel")}
          </Button>
          <Button disabled={disabled} onClick={onApply}>
            {t("assignation-edit.session-view.assign")}
          </Button>
        </div>
      }
    >
      <div className={styles.content}>{children}</div>
    </Drawer>
  );
};

export default AssignmentEditorDrawer;
